<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?'新增供应商档案':'修改供应商档案'}}</myNav>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-form-item :label="$t('cname')" prop="vendor_cname">
                <el-input v-model="formData.vendor_cname" :placeholder="$t('input')"></el-input>
            </el-form-item>
            <el-form-item label="API接口地址" prop="api_url">
                <el-input v-model="formData.api_url" :placeholder="$t('input')"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="信誉消费模式" prop="cr_cat">
                        <el-radio-group v-model="formData.cr_cat" :disabled="op == 'upd'">
                            <el-radio v-for="item in cr_cat" :key="item.value" :label="item.key">{{item.value}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="信誉额度" prop="cr_qty">
                        <el-input v-model="formData.cr_qty" :placeholder="$t('input')" :disabled="op == 'upd'"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="每日低于" prop="day_cr_qty_min">
                        <el-input v-model="formData.day_cr_qty_min">
                            <span slot="append">自动恢复<span class="f-blue">(填空不恢复)</span></span>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="商户号别称" prop="mac_id_nick">
                        <el-input v-model="formData.mac_id_nick" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="API秘钥别称" prop="api_key_nick">
                        <el-input v-model="formData.api_key_nick" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item :label="$t('sort')" prop="sort_id">
                        <el-input v-model="formData.sort_id" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item :label="$t('status')" prop="vendor_status">
                <el-radio-group v-model="formData.vendor_status">
                    <el-radio v-for="item in vendor_status" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                </el-radio-group>
                <span class="f-orange" v-if="op == 'upd'">（警告：停用后绑定的客户都无法下单！）</span>
            </el-form-item>
            <el-row v-if="op == 'upd'">
                <el-col :span="12"><el-form-item :label="$t('add_user')"><el-input v-model="formData.add_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('add_time')"><el-input v-model="formData.add_time" disabled></el-input></el-form-item></el-col>
            </el-row>
            <el-row v-if="op == 'upd'">
                <el-col :span="12"><el-form-item :label="$t('upd_user')"><el-input v-model="formData.upd_user" disabled></el-input></el-form-item></el-col>
                <el-col :span="12"><el-form-item :label="$t('upd_time')"><el-input v-model="formData.upd_time" disabled></el-input></el-form-item></el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <div class="f-red mg-right5">警告：资料修改将立即生效，请慎重</div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        components:{
        },
        data:function(){
            return{
                op: this.$base.getRequest().op,
                formData: {
                    vendor_id:'',
                    sort_id:'99',
                    vendor_cname : '',
                    cr_cat : '',
                    cr_qty : '',
                    day_cr_qty_min : '',
                    api_url : '',
                    mac_id_nick : '商户号',
                    api_key_nick : 'ApiKey',
                    vendor_status:'0',
                    add_user:'',
                    add_time:'',
                    upd_user:'',
                    upd_time:'',
                },
                rule: {
                    sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                    vendor_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    cr_cat: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    cr_qty: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    api_url: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    mac_id_nick: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    api_key_nick: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    vendor_status: [{required: true, message: this.$t('select'), trigger: 'change'}],
                },
                cr_cat:[],
                vendor_status:[]
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.formData.vendor_id = this.$base.getRequest().id;
            if(this.op == 'upd'){
                this.getInfo();
            }
            else{
                this.getLoad();
            }
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                this.$base.showLoading();
                this.$request.sendPost("vendor-code/before-add",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cr_cat = data.cr_cat;
                        this.vendor_status = data.vendor_status;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            getInfo: function(){
                var id = this.formData.vendor_id;
                if(!id){
                    return;
                }
                var data = {
                    vendor_id: id
                };
                this.$base.showLoading();
                this.$request.sendPost("vendor-code/before-upd",data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.formData = this.$base.leftJson(this.formData,data.info);
                        this.cr_cat = data.cr_cat;
                        this.vendor_status = data.vendor_status;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = this.op == 'upd' ? "vendor-code/upd" : "vendor-code/add";
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.msgSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/vendor/code/save.vue